
import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, UserCheck, MapPin, User, AlertTriangle, Calendar } from 'lucide-react';
import StatsSection from './StatsSection';
import PendingMembersSection from './PendingMembersSection';
import AllMembersSection from './AllMembersSection';
import MemberAnalyticsSection from './MemberAnalyticsSection';
import LimboMembersSection from './LimboMembersSection';
import RecentRegistrations from '../RecentRegistrations';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
        <p className="text-gray-700">Manage community members and view analytics</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-6">
          <TabsTrigger value="overview" className="flex items-center gap-2">
            <Users size={16} />
            Overview
          </TabsTrigger>
          <TabsTrigger value="recent" className="flex items-center gap-2">
            <Calendar size={16} />
            Recent
          </TabsTrigger>
          <TabsTrigger value="pending" className="flex items-center gap-2">
            <UserCheck size={16} />
            Pending
          </TabsTrigger>
          <TabsTrigger value="limbo" className="flex items-center gap-2">
            <AlertTriangle size={16} />
            Limbo
          </TabsTrigger>
          <TabsTrigger value="members" className="flex items-center gap-2">
            <User size={16} />
            All Members
          </TabsTrigger>
          <TabsTrigger value="analytics" className="flex items-center gap-2">
            <MapPin size={16} />
            Analytics
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="mt-6">
          <StatsSection />
        </TabsContent>

        <TabsContent value="recent" className="mt-6">
          <RecentRegistrations />
        </TabsContent>

        <TabsContent value="pending" className="mt-6">
          <PendingMembersSection />
        </TabsContent>

        <TabsContent value="limbo" className="mt-6">
          <LimboMembersSection />
        </TabsContent>

        <TabsContent value="members" className="mt-6">
          <AllMembersSection />
        </TabsContent>

        <TabsContent value="analytics" className="mt-6">
          <MemberAnalyticsSection />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDashboard;
